import { VersionControlState } from './types';

const initialState: VersionControlState = {
  createUserIntegrationAccount: {
    isLoading: false,
    error: '',
  },
  updateUserIntegrationAccount: {
    isLoading: false,
    error: '',
  },
  userIntegrationAccounts: {
    isLoading: false,
    error: '',
    data: null,
  },
  versionControlServers: {
    isLoading: false,
    data: null,
    error: '',
  },
  userGroups: {
    isLoading: false,
    data: null,
    error: '',
  },
  projectInfo: {
    isLoading: false,
    data: null,
    error: '',
  },
};
export default initialState;
